module.exports = __webpack_public_path__ + "img/settings-icon.1624d68a.svg";